export function binValidator(value: string) {
    // return value !== null && value.length >= 10 && value.length <= 13
    return value !== null && value.length >= 3
}

export function incorrectSymbolValidator(value: string) {
    if (value && value.includes('*')) return false
    return true
}

export function iinValidator(value: string) {
    return value !== null && value.length === 12
}

export function siteLink(value: string) {
    if (!value) return true

    const pattern = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.){1,}[a-zA-Z]{2,}(\/\S*)?$/
    return pattern.test(value)
}

export function dateRangeMin(value: string[] | Date[] | null) {
    if (!value) return true
    return value.length >= 2
}
